import round from "lodash/round";
import type { Currency } from "../data/BaseEntity";
import type { CostCurrency, CostStatus } from "./costApi";

export const statusToName = {
  NOT_PAID: "Niezapłacone",
  ADVANCE_PAYMENT: "Zaliczkowane",
  PAID: "Zapłacone",
  TO_CORRECT: "Do korekty",
} as const;

export function costStatusToName(status: CostStatus) {
  return statusToName[status];
}

export interface CostInvoice {
  amount?: number | null;
  exchangeRate?: number | undefined;
}

export function calculateMargin(
  price: number | null,
  orderCurrency: Currency,
  costCurrency: CostCurrency,
  invoices: CostInvoice[],
): number | null {
  const convertedCost = costAmountInOrderCurrency(orderCurrency, costCurrency, invoices);
  return price && convertedCost ? round(((price - convertedCost) * 100) / price, 2) : null;
}

export function costAmountInOrderCurrency(
  orderCurrency: Currency,
  costCurrency: CostCurrency,
  invoices: CostInvoice[],
) {
  return invoices
    .map((c) => costInvoiceAmountInOrderCurrency(orderCurrency, c.amount ?? null, costCurrency, c.exchangeRate))
    .reduce((prev, curr) => (prev === null || curr === null ? null : prev + curr), 0);
}

export function costInvoiceAmountInOrderCurrency(
  orderCurrency: Currency,
  cost: number | null,
  costCurrency: CostCurrency,
  exchangeRate: number | undefined,
) {
  if (orderCurrency === costCurrency) {
    return cost;
  }
  return exchangeRate && cost !== null ? cost * exchangeRate : null;
}
